import React, { useContext, useEffect, useState } from 'react';
import InputDefault from '../../../components/InputDefault';
import {
  TakerContainer,
  TakerWrapper,
  TakerContent,
  TakerLineFormLabel,
} from './styles';
import { Controller, useForm, useWatch } from 'react-hook-form';
import InputPhone from '../../../components/InputPhone';
import Loader from '../../../components/Loader';
import InputDate from '../../../components/InputDate';
import RadioButtonForm from '../../../components/RadioButtonForm';
import SearchField from '../../../components/SearchField';
import { SecondaryLargeButton } from '../../../components/Buttons/styles';
import {
  Form,
  FormRow,
  FormFooter
} from '../../../components/FormTemplate/styles';
import { ApSecureContext } from '../../../store';
import { default as ApSecureTypes } from "../../../store/ApSecure/types";
import { identificationType, maritalStatus } from '../../../helpers/enum';
import { handleChangeIdentification } from '../../../helpers/price';
import { getStates } from '../../../services/states';
import { getCities } from '../../../services/cities';
import { useLocation } from 'react-router-dom';
import { apSecureSteps } from '../../../helpers/enum';

const TakerPage = ({ setActiveStep }) => {
  const { apSecure, setApSecure } = useContext(ApSecureContext);
  const { control, errors, handleSubmit, register, clearErrors, setValue, watch } = useForm();
  const [showCity, setShowCity] = useState(false);
  const [showState, setShowState] = useState(false);
  const [cities, setCities] = useState([]);
  const [states, setStates] = useState([]);
  const [filteredCities, setFilteredCities] = useState([]);
  const [filteredStates, setFilteredStates] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const fields = watch();
  const emailValue = useWatch({ control, name: 'email' })

  async function initializedStateComponent() {
    try {
      if (apSecure.taker.state) {
        setValue('state', apSecure.taker.state.nombre)
      }

      if (apSecure.taker.city) {
        setValue('city', apSecure.taker.city.nombre)
      }

      const states = await getStates();

      setStates(states.data);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }

  async function onSubmit(data) {
    await setApSecure({
      type: ApSecureTypes.SET_TAKER_DATA,
      taker: {
        state: apSecure.taker.state,
        city: apSecure.taker.city,
        nombres_apellidos: data.nombres_apellidos,
        tipo_documento: apSecure.taker.tipo_documento,
        documento: data.documento,
        celular: data.celular,
        telefonoResidencia: data.telefonoResidencia,
        email: data.email,
        fechaNacimiento: data.fechaNacimiento,
        direccionResidencia: data.direccionResidencia,
        genero: apSecure.taker.genero,
      }
    });

    setActiveStep(apSecureSteps.BENEFICIARY);
  }

  function setSelectedCity(city) {
    setValue('city', city.nombre);
    setApSecure({
      type: ApSecureTypes.SET_TAKER_SELECTED_CITY,
      city
    });

    setShowCity(false);
  }

  async function setSelectedState(state) {
    try {
      setIsLoading(true);
      const cities = await getCities(state.id);
      setCities(cities.data);

      setValue('state', state.nombre);
      await setApSecure({
        type: ApSecureTypes.SET_TAKER_SELECTED_STATE,
        state
      });

      if(fields.city) {
        setValue('city', '');
        setApSecure({
          type: ApSecureTypes.SET_TAKER_SELECTED_CITY,
          city: {}
        });

        setShowCity(false);
      }

      setShowState(false);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }

  function searchInCities(e) {
    setShowCity(true);
    setShowState(false);
    const filtered = cities.filter(city => city.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    setFilteredCities(filtered);
  }

  function searchInState(e) {
    setShowState(true);
    setShowCity(false);
    const filtered = states.filter(city => city.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    setFilteredStates(filtered);
  }

  function setIdentificationRadioChecked(radio) {
    setApSecure({
      type: ApSecureTypes.SET_TAKER_IDENTIFICATION_TYPE,
      tipo_documento: radio.value,
      documento: ''
    })

    setValue('documento', '');
  }

  function onChangeIdentification(e) {
    if(apSecure.taker.tipo_documento === 'CE') {
      setValue('documento', e.target.value)
    } else {
      setValue('documento', handleChangeIdentification(e.target.value))
    }
  }

  function setGenderRadioChecked(genero) {
    setApSecure({
      type: ApSecureTypes.SET_TAKER_GENDER,
      genero: genero.value
    })
  }

  useEffect(() => {
    initializedStateComponent();

    return () => {
      setFilteredStates([]);
      setFilteredCities([]);
      setStates([]);
      setCities([]);
    }
  }, [])

  const onChangeEmail = (e) => {
    const lowercaseEmail = e.target.value.toLowerCase();
    setValue('email', lowercaseEmail);
  };

  useEffect(() => {
    const lowercaseEmail = emailValue.toLowerCase();
    setValue('email', lowercaseEmail);
  }, [emailValue, setValue]);

  return (
    <TakerContainer id="taker-page">
      <TakerWrapper>
        <TakerContent>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <TakerLineFormLabel>Datos del tomador - Vinculado (tomador del crédito)</TakerLineFormLabel>
            <FormRow col="1">
              <Controller
                as={InputDefault}
                control={control}
                error={errors.nombres_apellidos}
                label="Nome y Apellido"
                name="nombres_apellidos"
                id="nombres_apellidos"
                value={apSecure.taker.nombres_apellidos}
                register={register({ required: "Este dato es obligatorio" })} />
            </FormRow>
            <FormRow col="2">
              <RadioButtonForm
                label="Tipo de documento"
                setIdentificationRadioChecked={setIdentificationRadioChecked}
                selected={apSecure.taker.tipo_documento}
                name="tipo_documento"
                id="tipo_documento"
                radios={[
                  { label: 'CC', value: 'CC' },
                  { label: 'CE', value: 'CE' }
                ]} />
              <Controller
                name="documento"
                control={control}
                value={apSecure.taker.documento}
                render={() => (
                  <InputDefault
                    name="documento"
                    label="Número de documento de identidad"
                    register={register({ required: "Este dato es obligatorio" })}
                    id="documento"
                    error={errors.documento}
                    maxLength={apSecure.taker.tipo_documento === 'CE' ? identificationType.ce.max : identificationType.cc.max}
                    minLength={apSecure.taker.tipo_documento === 'CE' ? identificationType.ce.min : identificationType.ce.min}
                    onChange={onChangeIdentification}
                  />
                )}
              />
            </FormRow>
            <FormRow>
              <Controller
                as={InputPhone}
                control={control}
                label="Celular"
                name="celular"
                register={register({
                  required: "Este dato es obligatorio",
                  pattern: {
                    value: /^(?:30|31|32|33|34|35)([0-9]{1}) ([0-9]{3}) ([0-9]{2}) ([0-9]{2})$/,
                    message: "Error en el número, ingresa uno válido",
                  },
                })}
                id="celular"
                error={errors.celular}
                mask="999 999 99 99"
                value={apSecure.taker.celular} />
              <Controller
                as={InputPhone}
                control={control}
                label="Teléfono Residencia - Ingresar Iindicativo (Opcional)"
                name="telefonoResidencia"
                error={errors.telefonoResidencia}
                register={register({
                  pattern: {
                    value: /^([0-9]{1}) ([0-9]{2}) ([0-9]{2}) ([0-9]{2})$/,
                    message: "Error en el número, ingresa uno válido",
                  },
                })}
                id="telefonoResidencia"
                mask="9 99 99 99" />
            </FormRow>
            <FormRow>
              <Controller
                as={InputDefault}
                control={control}
                label="Correo Electrónico"
                name="email"
                onChange={onChangeEmail}
                register={register({
                  required: "Este dato es obligatorio",
                  pattern: {
                    value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                    message: "El correo electrónico tiene un formato inválido",
                  },
                })}
                id="email"
                error={errors.email}
                value={apSecure.taker.email} />
              <InputDate
                aria-required
                type="date"
                label="Fecha de nacimiento"
                name="fechaNacimiento"
                register={register({ required: "Este dato es obligatorio" })}
                id="fechaNacimiento"
                error={errors.fechaNacimiento}
                onBlur={() => { }} />
            </FormRow>
            <FormRow>
              <SearchField
                label="Departamento de Residencia"
                name="state"
                id="state"
                show={showState}
                list={filteredStates}
                defaultValue={apSecure.taker.state.nombre}
                selectField={setSelectedState}
                searchInList={searchInState}
                register={register({ required: "Este dato es obligatorio" })}
                placeholder="Buscar..."
                error={errors.state} />
              <SearchField
                label="Ciudad o Municipio de Residencia"
                name="city"
                id="city"
                show={showCity}
                list={filteredCities}
                defaultValue={apSecure.taker.city.nombre}
                selectField={setSelectedCity}
                searchInList={searchInCities}
                register={register({ required: "Este dato es obligatorio" })}
                placeholder="Buscar..."
                error={errors.city}
                disabled={!apSecure.taker.state} />
            </FormRow>
            <FormRow>
              <Controller
                as={InputDefault}
                control={control}
                error={errors.direccionResidencia}
                label="Directión Residencia"
                name="direccionResidencia"
                id="direccionResidencia"
                value={apSecure.taker.direccionResidencia}
                register={register({ required: "Este dato es obligatorio" })} />
              <RadioButtonForm
                label="Genero"
                setIdentificationRadioChecked={setGenderRadioChecked}
                selected="m"
                name="genero"
                id="genero"
                selected={apSecure.taker.genero}
                radios={[
                  { label: 'M', value: 'M' },
                  { label: 'F', value: 'F' }
                ]} />
            </FormRow>
            <FormFooter justify="flex-end">
              <SecondaryLargeButton type="submit">Siguiente</SecondaryLargeButton>
            </FormFooter>
          </Form>
        </TakerContent>
      </TakerWrapper>
      {isLoading && <Loader />}
    </TakerContainer>
  )
}

export default TakerPage;
